<template>
  <div :class="`cnc-loading ${sizeLoading[size]} ${getOnColor} ${full &&'center2D position-fixed'}`" :data-qa="`${qa ? `loading-${qa}` : 'loading' }`">
    <img v-if="!onColor" class="loading-spinner" src="../images/loading-on-base.png" :width="getWidth">
    <img v-else class="loading-spinner" src="../images/loading-on-color.png" :width="getWidth">
    <div v-if="withText && size === 'large'" class="loading-text">Loading</div>
  </div>
</template>

<script>
export default {
  props: {
    size: { type: String, default: 'large' },
    withText: { type: Boolean },
    onColor: { type: Boolean },
    qa: { type: String },
    full: { type: Boolean }
  },
  data () {
    return {
      sizeLoading: {
        'large': 'loading-large',
        'small': 'loading-small'
      }
    }
  },
  computed: {
    getWidth () {
      if (this.size === 'large') return 40
      else return 24
    },
    getOnColor () {
      if (this.onColor) return 'loading-on-color'
      else return 'loading-on-base'
    }
  }
}
</script>

<style lang="scss">
.cnc-loading{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .loading-spinner{
    animation: spinner-rotate .6s infinite linear;
  }

  @keyframes spinner-rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  &.loading-large{

    .loading-text{
      font-size: 14px;
      margin-top: 8px;
      color: $color-cool-grey-500;
    }
  }

  &.loading-on-color{
    .loading-text{
      font-size: 14px;
      margin-top: 8px;
      color: $color-white;
    }
  }
}
</style>
